import {AccountsAccessRightsControlsCollectionItemInterface} from '../interfaces';

import {AccountAccessRightControl} from './account-access-right-control';

export class AccountsAccessRightsControlsCollection {
    private readonly items: AccountsAccessRightsControlsCollectionItemInterface[];

    private errors: string[];

    constructor(items?: AccountsAccessRightsControlsCollectionItemInterface[]) {
        this.items = !items ? [] : items;
    }

    setItems(items: AccountsAccessRightsControlsCollectionItemInterface[]): void {
        this.items.push(...items);
    }

    getControlsCols(accountId: number): number[] {
        const cols = this.items.filter((item: AccountsAccessRightsControlsCollectionItemInterface) => {
            return item.accountId === accountId;
        }).reduce((reducedCols: number[], item: AccountsAccessRightsControlsCollectionItemInterface) => {
            item.controls.forEach((control: AccountAccessRightControl) => {
                reducedCols.push(control.position.col);
            });

            return reducedCols;
        }, []);

        return cols.filter((col: number, index: number) => {
            return cols.indexOf(col) === index;
        }).sort((current: number, next: number) => {
            return current - next;
        });
    }

    getItems(): AccountsAccessRightsControlsCollectionItemInterface[] {
        return this.items;
    }

    getControlsRowsByCol(accountId: number, col: number): number[] {
        return this.items.filter((item: AccountsAccessRightsControlsCollectionItemInterface) => {
            return item.accountId === accountId;
        }).reduce((reducedRows: number[], item: AccountsAccessRightsControlsCollectionItemInterface) => {
            item.controls.filter((control: AccountAccessRightControl) => {
                return control.position.col === col;
            }).forEach((control: AccountAccessRightControl) => {
                reducedRows.push(control.position.row);
            });

            return reducedRows;
        }, []);
    }


    getControlByPosition(accountId: number, col: number, row: number): AccountAccessRightControl {
        const filteredControls = this.items.filter((item: AccountsAccessRightsControlsCollectionItemInterface) => {
            return item.accountId === accountId;
        }).reduce((
            reducedControls: AccountAccessRightControl[],
            item: AccountsAccessRightsControlsCollectionItemInterface
        ) => {
            item.controls.filter((control: AccountAccessRightControl) => {
                return (control.position.col === col) && (control.position.row === row);
            }).forEach((control: AccountAccessRightControl) => {
                reducedControls.push(control);
            });

            return reducedControls;
        }, []);

        if (filteredControls.length > 0) {
            return filteredControls[0];
        }

        return null;
    }

    setErrors(value: string[]): void {
        this.errors = value;
    }

    resetErrors(): void {
        this.errors.splice(0, this.errors.length);
    }
}
